module.exports = {
  usersCommented: 'hat kommentiert | haben kommentiert',
  deletion_is_irreversible: 'Diese Aktion kann nicht rückgängig gemacht werden.',
  cancelReply: 'Antwort abbrechen',
  report_reasons: {
    reason_misc: 'Anderer Grund',
    reason_offensive: 'Beleidigende Inhalte',
    reason_personal_rights: 'Verletzung von Persönlichkeitsrechten',
    reason_advertisement: 'Unerlaubte Werbung',
  },
  loading: 'Laden...',
  read_more: 'weiterlesen',
  comments: 'Kommentare',
  loadingComments: 'Kommentare werden geladen...',
  submit: 'Absenden',
  deleteAnswer: {
    title: 'Antwort löschen?',
    confirmation: 'Diese Antwort und ihre Unterhaltungen werden dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.',
    typeDelete: 'Gib DELETE ein, um zu bestätigen.',
    success: 'Antwort gelöscht.',
    error: 'Antwort konnte nicht gelöscht werden. Bitte versuche es später erneut.',
  },
  deleted_by_admin: 'Kommentar durch Administrator entfernt.',
  deleted_by_user: 'Kommentar vom User gelöscht.',
  comment_is_added: 'Kommentar erfolgreich gepostet.',
  reporting_success: 'Der Kommentar wurde gemeldet.',
  deletion_success: 'Dein Kommentar wurde gelöscht.',
  posting_failed: 'Dein Kommentar konnte nicht gepostet werden, bitte versuche es später erneut.',
  reporting_failed: 'Kommentar konnte nicht gemeldet werden, bitte versuche es später erneut.',
  deletion_failed: 'Kommentar konnte nicht gelöscht werden, bitte versuche es später erneut.',
  commentPlaceholder: 'Kommentieren...',
  write_message: 'Nachricht verfassen',
  write_reply: 'Antwort verfassen',
  attachments: {
    size_limit: 'Die Maximale Dateigröße beträgt 10MB',
    load_more: 'Ein weiteres Bild laden | {count} weitere Bilder laden',
    count_limit: 'Du kannst maximal 10 Dateien bei deinem Kommentar hochladen',
  },
  noComments: 'Noch keine Kommentare',
  comment_is_sending: 'Dateien werden hochgeladen...',
  no_comments_yet: 'Es gibt noch keine Kommentare.',
  beFirstToComment: 'Kommentiere als erstes!',
  upload_file: 'Datei hochladen',
  vips: {
    coursemanager: 'Kursleitung',
  },
  messages_to_course_management: 'Nachrichten an die Kursleitung',
  errorLoadingComments: 'Die Kommentare konnten nicht geladen werden. Bitte versuche es erneut.',
  no_messages_yet: 'Es gibt noch keine Nachrichten.',
  report_comment: 'Kommentar melden',
  reply: 'Antworten',
  more_replies: 'weitere Antwort | weitere Antworten',
  approveReply: 'Hilfreiche Antwort',
  helpfulReply: 'Hilfreich',
  write_comment: 'Kommentar verfassen',
  write_comment_placeholder: 'Kommentar verfassen…',
  reply_to_x: 'Antwort an %{username} verfassen',
  loadMore: 'Weitere Kommentare laden',
  verifiedMessage: 'Ein Admin hat diese Antwort bestätigt',
  delete_comment: 'Kommentar löschen',
  delete_comment_question: 'Kommentar löschen?',
  translate: 'Übersetzen',
  showOriginal: 'Original anzeigen',
  replyPlaceholder: 'Antwort schreiben...',
  translatedFrom: 'Übersetzt aus {language}:',
  approveReplyShort: 'Hilfreich',
  approvedReply: 'Bestätigte Antwort',
  helpfulAnswers: 'Hilfreiche Antworten',
}
